/**
 * Test invitation loaded inside its own iframe
 */

/**
 * client/wrapper type for the Test widget on parent/page, it is responsible for wrapper div.
 */
import WidgetStates from '../core/hooks/WidgetStates';
import BaseWidgetClient from '../core/BaseWidgetClient';
import WidgetTypes from '../core/enums/WidgetTypes';
import GlobalVariables from '../core/GlobalVariables';
import createLinkElementInDOM from '../core/hooks/createLinkElementInDOM';
import createNS from '../core/createNs';

export default function RegisterWebSMS() {
    const WebSmsForm = class extends BaseWidgetClient {
        constructor(options) {
            // if (!options.implementTestWidget) {//in case we have a portal level flag for this
            //    return;
            // }
            super(
                Object.assign(options, {
                    widget: WidgetTypes.WebSmsForm // containerBg: 'blue'
                })
            );
            this.ready();
        }

        ready() {
            super.ready();
            const me = this;
            me.subscribe(WidgetTypes.WebSmsForm + WidgetStates.Hidden, () => {
                if (!me.$) {
                    me.$ = ApexChat.ApexChatJquery;
                }
                me.$(me.$container).fadeOut('slow');
            });
            me.create();
        }

        create() {
            super.create();
            const self = this;
            self.$container.innerHTML = `<iframe  class="${self.widget}_frame"   id="${self.iframeId}"  style="border: none;overflow-x:hidden; overflow-y:hidden;" marginheight="0" marginwidth="0" frameBorder="0" scrolling="no" horizontalscrolling="no" verticalscrolling="no"  allowtransparency="true"></iframe>`;
            document.body.appendChild(self.$container);
            createLinkElementInDOM(
                `${GlobalVariables.CdnBaseUrl}contents/scripts/dist/${ApexChat.Theme}/sms.css?ver=${env.BUILD_HASH}`
            );

            // addStyleText(
            //     parseTemplate(self.options.smsPopupFrameStyles, {
            //         iframeID: `#${self.iframeId}`
            //     })
            // );
            // getStyleForIframe(
            //     `${GlobalVariables.CdnBaseUrl}contents/scripts/dist/webSmsFormInvitation.css`,
            //     'smsiframe',
            //     undefined,
            //     this.DOM
            // );
            this.show();
        }

        show() {
            super.show();
        }

        hide() {
            super.hide();
        }
    };
    const fqName = `${WidgetTypes.WebSmsForm}_client`;
    // Export to window
    createNS(fqName, WebSmsForm);
}
